export default __webpack_public_path__ + "static/media/hht2_Intonation_16.9f78c481.png";